/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactSummaryResponseDtoSchema } from "../contactSummaryResponseDtoSchema";
import { z } from "zod/v4";

export const getContactSummaryPathParamsSchema = z.object({
    "contactId": z.uuid()
    })

export const getContactSummaryHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description AI-generated summary for the contact
 */
export const getContactSummary200Schema = z.lazy(() => contactSummaryResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const getContactSummary401Schema = z.any()

export const getContactSummaryQueryResponseSchema = z.lazy(() => getContactSummary200Schema)